module.exports = __webpack_public_path__ + "static/media/header-5.2896e8b3.png";